module.exports = __webpack_public_path__ + "img/bar-chart-black.1b59714d.svg";